import { TableCard } from '../../../../components'
import { ListViewProvider } from './core/ListViewProvider'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { FinanceiroAtendimentosTable } from './table/FinanceiroAtendimentosTable'
import { FinanceiroAtendimentosListHeader } from './components/header/FinanceiroAtendimentosListHeader'

const FinanceiroAtendimentosList = () => {
  return (
    <TableCard>
      <FinanceiroAtendimentosListHeader />
      <FinanceiroAtendimentosTable />
    </TableCard>
  )
}

export const FinanceiroAtendimentosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <FinanceiroAtendimentosList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
